export const preventRedirectOn401Pahtnames = [
  '/c/about-us',
  '/c/careers',
  '/contact-us',
  '/pricing',
  '/careers',
  '/community',
  '/ai-certification',
  '/privacy-policy',
  '/state-and-district-privacy-agreements',
  '/cookie-policy',
  '/ai-in-curipod',
  '/safe-ai-in-curipod',
  '/terms-of-use',
  '/gdpr',
  '/ai',
  '/daily-icebreaker',
  '/accelerator',
  '/creators',
  '/business',
  '/accessibility',
];

export default {
  logger: {
    type: 'cloud_run_revision',
    loggerName: 'curipod-com',
  },
};
